module.exports = __webpack_public_path__ + "static/assaabloy-cdf1d8479e013b99ab55dfc6214a3a86.png";